const PublicLayoutStyle = (theme) => ({

});

export default PublicLayoutStyle;
